import React, { ReactNode } from 'react'

interface NothingLayoutProps {
  children: ReactNode
}

const NothingLayout: React.FC<NothingLayoutProps> = ({ children }) => {
  return <>{children}</>
}

export default NothingLayout
